<template>
  <div class="ws-connection-status">
    <a-tag 
      :color="statusColor" 
      :style="{ cursor: showDetails ? 'pointer' : 'default' }"
    >
      <a-icon :type="statusIcon" :spin="$wsStatus.connecting" />
      {{ statusText }}
    </a-tag>

    <!-- Detailed status popover -->
    <a-modal
      v-if="showDetails"
      v-model="detailsVisible"
      title="WebSocket Connection Details"
      :footer="null"
      width="400px"
    >
      <div class="ws-details">
        <a-descriptions :column="1" size="small">
          <a-descriptions-item label="Status">
            <a-tag :color="statusColor">{{ statusText }}</a-tag>
          </a-descriptions-item>
          
          <a-descriptions-item label="Connected">
            {{ $wsStatus.connected ? 'Yes' : 'No' }}
          </a-descriptions-item>
          
          <a-descriptions-item label="Subscribed Channels">
            <div v-if="$wsStatus.channels.length > 0">
              <a-tag v-for="channel in $wsStatus.channels" :key="channel" color="blue">
                {{ channel }}
              </a-tag>
            </div>
            <span v-else class="text-muted">None</span>
          </a-descriptions-item>
          
          <a-descriptions-item v-if="$wsStatus.error" label="Last Error">
            <a-tooltip :title="errorDetails">
              <a-tag color="red">{{ errorSummary }}</a-tag>
            </a-tooltip>
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'ConnectionStatus',
  props: {
    showDetails: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'default' // 'large', 'default', 'small'
    }
  },
  data() {
    return {
      detailsVisible: false
    };
  },
  computed: {
    statusColor() {
      if (this.$wsStatus.connected) return 'green';
      if (this.$wsStatus.error) return 'red';
      if (this.$wsStatus.connecting) return 'orange';
      return 'default';
    },
    
    statusIcon() {
      if (this.$wsStatus.connected) return 'wifi';
      if (this.$wsStatus.connecting) return 'loading';
      return 'disconnect';
    },
    
    statusText() {
      if (this.$wsStatus.connected) return 'Live Updates Connected';
      if (this.$wsStatus.connecting) return 'Connecting...';
      if (this.$wsStatus.error) return 'Live Updates Not Connected';
      return 'Disconnected';
    },
    
    errorSummary() {
      if (!this.$wsStatus.error) return '';
      return this.$wsStatus.error.type || 'Unknown Error';
    },
    
    errorDetails() {
      if (!this.$wsStatus.error) return '';
      return JSON.stringify(this.$wsStatus.error, null, 2);
    }
  },
  methods: {
    toggleDetails() {
      this.detailsVisible = !this.detailsVisible;
    },
  }
};
</script>

<style lang="scss" scoped>
.ws-connection-status {
  display: inline-block;
}

.ws-details {
  .text-muted {
    color: #999;
    font-style: italic;
  }
}

.ws-actions {
  text-align: center;
  
  .ant-btn {
    margin: 0 4px;
  }
}
</style>
